/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseReferentialCategory } from '../../models/api-response-referential-category';

export interface GetReferentialCategoryByRef$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
}

export function getReferentialCategoryByRef(http: HttpClient, rootUrl: string, params: GetReferentialCategoryByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialCategory>> {
  const rb = new RequestBuilder(rootUrl, getReferentialCategoryByRef.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseReferentialCategory>;
    })
  );
}

getReferentialCategoryByRef.PATH = '/v1/api/ui/referential/category/{ref}';
